<div
  #chartContainer
  data-testid="radar-chart-container"
  [class]="className"
  [style.height]="height"
  [style.width]="width"
></div>
